import React from 'react';
import { MapPin } from 'lucide-react';
export function Footer() {
  const scrollTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="w-full bg-[#080c12] border-t border-[#1e2a3a] py-10 px-4 sm:px-6" data-id="element-56">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-57">
        {/* Brand */}
        <div className="flex items-center gap-3" data-id="element-58">
          <img src="https://cdn.magicpatterns.com/uploads/iZx6wcW2kMqVcgUNkeyzh3/elitepoolz.jpg" alt="Elite Poolz" className="h-10 w-10 rounded-full object-cover" data-id="element-59" />
          <div data-id="element-60">
            <p className="font-black text-white text-base leading-tight" data-id="element-61">
              ELITE <span className="text-[#2979ff]" data-id="element-62">POOLZ</span>
            </p>
            <p className="text-gray-500 text-xs flex items-center gap-1 mt-0.5" data-id="element-63">
              <MapPin size={10} data-id="element-64" /> Arizona
            </p>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-65">
          {['#services', '#gallery', '#why-us', '#contact'].map(href => <button key={href} onClick={() => scrollTo(href)} className="hover:text-[#2979ff] transition-colors capitalize" data-id="element-66">
              {href.replace('#', '').replace('-', ' ')}
            </button>)}
        </nav>

        {/* Copyright */}
        <p className="text-gray-600 text-xs text-center" data-id="element-67">
          © {new Date().getFullYear()} Elite Poolz. All rights reserved.
        </p>
      </div>
    </footer>;
}